<template>
  <div class="min-h-screen bg-gray-50">
    <div class="max-w-7xl mx-auto px-4 py-8">
      <!-- 头部区域 -->
      <div class="flex justify-between items-center mb-8">
        <h1 class="text-2xl font-bold">会员统计</h1>
        <div class="flex items-center space-x-4">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="large"
            class="!rounded-button"
            @change="loadData"
          />

           <el-button type="primary" class="!rounded-button whitespace-nowrap" @click="querys">
            查询
          </el-button>

          <!-- <el-button type="primary" class="!rounded-button whitespace-nowrap" @click="exportData">
            <el-icon class="mr-1"><Download /></el-icon>导出数据
          </el-button> -->
        </div>
      </div>

      <!-- 数据概览卡片 -->
      <div class="grid grid-cols-4 gap-6 mb-8">
        <div v-for="(card, index) in overviewCards" :key="index" 
          class="bg-white p-6 rounded-lg shadow-sm">
          <div class="flex items-center justify-between">
            <span class="text-gray-600">{{ card.title }}</span>
            <el-icon :class="card.iconClass"><component :is="card.icon" /></el-icon>
          </div>
          <div class="mt-4">
            <span class="text-2xl font-bold">{{ card.value }}</span>
            <!-- <span class="ml-2 text-sm" :class="card.trend > 0 ? 'text-green-500' : 'text-red-500'">
              {{ card.trend > 0 ? '+' : '' }}{{ card.trend }}%
            </span> -->
          </div>
        </div>
      </div>

      <!-- 图表区域 -->
      <div class="bg-white p-6 rounded-lg shadow-sm mb-8">
        <div ref="chartRef" class="w-full h-[400px]"></div>
      </div>

      <!-- 业务员列表 -->
      <div class="bg-white rounded-lg shadow-sm">
        <el-table :data="tableData" stripe v-loading="loading">
          <el-table-column label="业务员" width="200">
            <template #default="{ row }">
              <div class="flex items-center">
                <el-avatar :size="32" :src="row.avatar" />
                <span class="ml-2">{{ row.name }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="memberCount" label="负责会员数" sortable />


           <el-table-column prop="totalConsumption_nofinish" label="会员消费总额-未完成-微信" sortable>
            <template #default="{ row }">
              ¥ {{ row.totalConsumption_nofinish.toLocaleString() }}
            </template>
          </el-table-column>

          
          
          <el-table-column prop="totalConsumption_finsh" label="会员消费总额-已完成-微信" sortable>
            <template #default="{ row }">
              ¥ {{ row.totalConsumption_finsh.toLocaleString() }}
            </template>
          </el-table-column>


          <el-table-column prop="totalConsumptionAll" label="会员消费总订单总额-微信" sortable>
            <template #default="{ row }">
              ¥ {{ row.totalConsumptionAll.toLocaleString() }}
            </template>
          </el-table-column>




        <el-table-column prop="jiesuan" label="结算金额(8%)基于【会员消费完成订单总额】"  />


           <el-table-column prop="totalConsumption_nofinish_banl" label="会员消费总额-未完成-余额" sortable>
            <template #default="{ row }">
              ¥ {{ row.totalConsumption_nofinish_banl.toLocaleString() }}
            </template>
          </el-table-column>

          
          
          <el-table-column prop="totalConsumption_finsh_banl" label="会员消费总额-已完成-余额" sortable>
            <template #default="{ row }">
              ¥ {{ row.totalConsumption_finsh_banl.toLocaleString() }}
            </template>
          </el-table-column>


          <el-table-column prop="totalConsumptionAll_banl" label="会员消费总订单总额-余额" sortable>
            <template #default="{ row }">
              ¥ {{ row.totalConsumptionAll_banl.toLocaleString() }}
            </template>
          </el-table-column>
                    

          <el-table-column prop="newMembers" label="新增会员数" sortable />
         
   
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

 import StatisticsApi from '@/api/statistics.js';
export default {
  components: {

  },
  data() {
    return {
      dateRange: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
      timeUnit: 'month',
      chart: null,
      loading: false,
      overviewCards: [
        {
          title: '总会员数',
          value: '0',
          trend: 0,
          icon: 'User',
          iconClass: 'text-blue-500'
        },
        {
          title: '新增会员数',
          value: '0',
          trend: 0,
          icon: 'UserPlus',
          iconClass: 'text-green-500'
        },
        {
          title: '会员消费总额',
          value: '¥ 0',
          trend: 0,
          icon: 'Money',
          iconClass: 'text-orange-500'
        },
        {
          title: '会员活跃度',
          value: '0%',
          trend: 0,
          icon: 'TrendingUp',
          iconClass: 'text-purple-500'
        }
      ],
      tableData: []
    };
  },
  mounted() {
    this.initChart();
    this.loadData();
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartRef);
    },
    async loadData() {
      this.loading = true;
        var self = this;
      // 格式化日期参数
        const params = {
          startDate: this.formatDate(this.dateRange[0]),
          endDate: this.formatDate(this.dateRange[1]),
          timeUnit: this.timeUnit
        };

       StatisticsApi.ywy_index(params)
         .then(res => {
             const data = res.data;
        
                    // 更新概览卡片
            self.overviewCards = data.overview;
            
            // 更新图表
            self.updateChart(data.chart);
            
            // 更新业务员列表
            self.tableData = data.salesman

            this.loading = false;
         })
         .catch(error => {});
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    updateChart(chartData) {
      const option = {
        animation: false,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        legend: {
          data: ['消费金额', '会员数量']
        },
        grid: {
          right: '5%',
          left: '3%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: chartData.xAxis
        },
        yAxis: [
          {
            type: 'value',
            name: '消费金额',
            axisLabel: {
              formatter: '{value} 万'
            }
          },
          {
            type: 'value',
            name: '会员数量',
            axisLabel: {
              formatter: '{value} 人'
            }
          }
        ],
        series: [
          {
            name: '消费金额',
            type: 'bar',
            data: chartData.consumption
          },
          {
            name: '会员数量',
            type: 'line',
            yAxisIndex: 1,
            data: chartData.members
          }
        ]
      };
      
      this.chart.setOption(option);
    },
    querys(){
        this.loadData();
    },
    async exportData() {
      try {
        const params = {
          startDate: this.formatDate(this.dateRange[0]),
          endDate: this.formatDate(this.dateRange[1])
        };
        
        // 调用导出接口
        const response = await this.$http.post('/member/export', params, {
          responseType: 'blob'
        });
        
        // 创建下载链接
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `会员统计_${new Date().toLocaleString()}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('导出数据失败:', error);
        this.$message.error('导出数据失败');
      }
    },
    viewDetail(row) {
      // 查看详情逻辑，可以跳转到业务员详情页面
      this.$router.push({
        path: '/salesman/detail',
        query: {
          id: row.id,
          startDate: this.formatDate(this.dateRange[0]),
          endDate: this.formatDate(this.dateRange[1])
        }
      });
    }
  },
  beforeUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
};
</script>

<style scoped>
.el-date-picker {
  --el-date-editor-width: 320px;
}

:deep(.el-range-editor.el-input__wrapper) {
  border-radius: 6px;
}

:deep(.el-select .el-input__wrapper) {
  border-radius: 6px;
}

:deep(.el-button) {
  border-radius: 6px;
}
</style>


// WEBPACK FOOTER //
// src/views/statistics/ywy/index.vue